import type { Permission, CurrentUser } from '@brimostech/shared';
import { useAuth } from '@/features/auth/auth-context';

/** True when the current user has any of the permissions (operators always do). */
export function useCan(...permissions: Permission[]): boolean {
  const { user } = useAuth();
  if (!user) return false;
  if (user.isSuperadmin) return true;
  return permissions.some((p) => user.permissions.includes(p));
}

/** Residents use the app: an account whose every membership is "morador" has nothing in the portal (ADR-102). */
export function residentOnly(user: CurrentUser): boolean {
  return (
    !user.isSuperadmin &&
    user.condominiums.length > 0 &&
    user.condominiums.every((c) => c.role === 'morador')
  );
}
